import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/channels")({
  component: ChannelsLayout,
});

function ChannelsLayout() {
  return <Outlet />;
}
